export default __webpack_public_path__ + "static/oscar-bitmoji-73d7b8240fd0b6af93c4722fa7832a99.png";